import React, { useEffect, useState } from 'react';

import { Box } from '@mui/material';

import { subscribeLensAnnouncer } from './lensAnnouncer';

/**
 * Mounted once for the Lens surface, by LeLensPage. Any control
 * anywhere in the tree announces through announceLensFilter, and this is the
 * one place that renders the result, so a screen reader hears exactly one
 * polite announcement per filter change rather than one per mounted control.
 */
export default function LensLiveRegion() {
  const [message, setMessage] = useState('');

  useEffect(() => subscribeLensAnnouncer((announcement) => setMessage(announcement.message)), []);

  return (
    <Box
      aria-atomic="true"
      aria-live="polite"
      role="status"
      sx={{
        position: 'absolute',
        width: '1px',
        height: '1px',
        margin: '-1px',
        padding: 0,
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        whiteSpace: 'nowrap',
        border: 0,
      }}
    >
      {message}
    </Box>
  );
}
